import type { IRestEndpointConfig } from '@deity-io/di-data-flows';
import React from 'react';

export enum EndpointActionTypes {
  INIT_ENDPOINT_CONFIG = 'INIT_ENDPOINT_CONFIG',
  SET_VALUE = 'SET_VALUE',
  UNSET_VALUE = 'UNSET_VALUE'
}

export interface ISetValuePayload {
  key: string[];
  value: any;
}

export interface IInitEndpointConfig {
  type: EndpointActionTypes.INIT_ENDPOINT_CONFIG;
  payload: IRestEndpointConfig & {
    uuid: string;
    packageVersionUuid: string;
  };
}

export interface ISetValue {
  type: EndpointActionTypes.SET_VALUE;
  payload: ISetValuePayload;
}

export interface IUnsetValue {
  type: EndpointActionTypes.UNSET_VALUE;
  payload: { key: string[] };
}

export type EndpointActions = IInitEndpointConfig | ISetValue | IUnsetValue;

export interface IEndpointConfigState extends Partial<IRestEndpointConfig> {
  uuid?: string;
  packageVersionUuid?: string;
}

export interface EndpointContextInterface {
  state: IEndpointConfigState;
  dispatch: (endpointActions: EndpointActions) => void;
}
export const EndpointContext = React.createContext<EndpointContextInterface | null>(null);
